import styled from "styled-components";
import { Box } from "./box";

const Gap = styled.div`
  height: ${({ height }) => (height ? height + "px" : `0px`)};
  width: ${({ width }) => (width ? width + "px" : `0px`)};
`;

const HGap = styled(Box)`
  width: ${({ width }) => width};
`;

const VGap = styled(Box)`
  height: ${({ height }) => height};
`;

const HRLine = styled.div`
  width: ${({ width }) => width || `100%`};
  height: 1px;
  opacity: ${({ opacity }) => opacity || 1};
  background: ${({ color }) => color || "#fff"};
`;

const VRLine = styled.div`
  height: 100%;
  width: 1px;
  color: ${({ color }) => color && "#fff"};
`;

export { Gap, HRLine, VRLine, HGap, VGap };
